<ng-container *ngIf="!file; else uploaded">
  <div
    id="file"
    class="upload-file upload-dragdrop p-2 w-100"
    appDragDrop
    (click)="fileInput.click()"
    (onFileDropped)="onFileDrop($event)">
      <input hidden type="file" #fileInput (change)="onFileUpload($event)" [accept]="accept">

      <div class="upload-dragdrop-image">
        <img src="assets/upload-drag-drop-icon.svg" alt="imagealt" aria-hidden="true">
      </div>

      <div class="upload-dragdrop-text">
        <h6 class="mb-1">{{'DRAG_FILE' | translate}}</h6>
        <div class="text-center">{{'OR' | translate}}</div>
        <div class="btn btn-link text-center p-1">{{'SELECT_FROM_DEVICE' | translate}}</div>
      </div>
  </div>
</ng-container>
<ng-template #uploaded>
  <div class="col upload-dragdrop success p-2">
    <div class="upload-dragdrop-image">
      <img src="assets/upload-drag-drop-icon.svg" alt="imagealt" aria-hidden="true">
      <div class="upload-dragdrop-loading"></div>
      <div class="upload-dragdrop-success">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="assets/svg/sprite.svg#it-check"></use>
        </svg>
      </div>
    </div>
    <div class="col upload-dragdrop-text">
      <p class="upload-dragdrop-weight">
        <svg class="icon icon-xs" aria-hidden="true">
          <use xlink:href="assets/svg/sprite.svg#it-file"></use>
        </svg>
        PDF ({{ size }} MB)
      </p>
      <h5 style="overflow-wrap: anywhere">{{ filename }}</h5>
      <p>{{'LOAD_COMPLETE' | translate}}</p>
    </div>
    <input value="Submit" type="submit" class="d-none"/>
  </div>

  <div class="row justify-content-center p-3">
    <button (click)="changeFile()" class="btn btn-outline-secondary btn-sm" type="button">
      {{'BUTTON.CHANGE_FILE'|translate}}
    </button>
  </div>
</ng-template>
